<template>

  <div class="tes-blog__nav-info">
    <ul class="tes-blog__breadcrumbs"
        itemscope itemtype="http://schema.org/BreadcrumbList">

      <template v-for="(item, index) in items.items()">
        <li class="tes-blog__breadcrumb"
            itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
          <template v-if="!item.here()">
              <a  v-if="typeof item.url() == 'string'" :href="String(item.url())" class="tes-blog__breadcrumb-item-link"
                 itemprop="item"><span itemprop="name">{{item.title()}}</span></a>
              <router-link :to="item.url()" class="tes-blog__breadcrumb-item-link"
                 itemprop="item" v-else><span itemprop="name">{{item.title()}}</span></router-link>
          </template>
          <template v-else>
            <span class="tes-blog__breadcrumb-item-link">
              <span itemprop="name">{{item.title()}}</span>
            </span>
          </template>
          <meta itemprop="position" :content="String(index + 1)" />
        </li>
      </template>

    </ul>
    <div class="tes-blog__pagination-delimiter" v-if="pagination && pagination?.currentPage() > 0">
      <span class="tes-blog__pagination-delimiter-title"> Страница: {{ pagination?.currentPage() }}</span>
    </div>
  </div>

</template>

<script lang="ts">
import {PropType} from "vue";
import {PaginationInterface} from "../objects/Paginator";
import {BreadcrumbsInterface} from "../objects/Breadcrumb";

export default {
  name: 'BreadcrumbView',
  props: {
    pagination: {
      type: Object as PropType<PaginationInterface | null>,
      required: false,
      default: null
    },
    items: {
      type: Object as PropType<BreadcrumbsInterface>,
      required: true,
      default: []
    }
  }
}
</script>
